<div [class]="styleClass">
    <h3> {{ title }} </h3>
    <a class="close" (click)="closeInformative()"><i [class]="iconClass"></i></a>
</div>